import { SECTION_PARAM } from './SectionTabs';

export enum SaleSection {
  SUMMARY = 'summary',
  POOLS = 'pools',
  BIDS = 'bids',
  DOCUMENTS = 'documents',
}

export const SALE_SECTION_LABEL: Record<SaleSection, string> = {
  [SaleSection.SUMMARY]: 'Summary',
  [SaleSection.POOLS]: 'Pools',
  [SaleSection.BIDS]: 'Bids',
  [SaleSection.DOCUMENTS]: 'Documents',
};

export const saleSectionPath = (saleId: string, section: SaleSection) =>
  section === SaleSection.SUMMARY
    ? `/sales/${saleId}`
    : `/sales/${saleId}?${SECTION_PARAM}=${section}`;
